import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

// Supabase publishable credentials (safe to embed - these are public keys)
const SUPABASE_URL = "https://ultknizonvqwrnhkblwm.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVsdGtuaXpvbnZxd3JuaGtibHdtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM2OTQwMTgsImV4cCI6MjA2OTI3MDAxOH0.91k__d59sgTgUOqN44g0xf043msG_E4pbkyJpWfZpRg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
});

/**
 * Invokes the analyze-crop-image edge function
 * @param image - Image URL or base64 encoded image (required)
 * @param cropType - Optional crop type for better analysis context
 * @returns Promise with the response data (analysis and timestamp) and error
 */
export async function analyzeCropImage(params: {
  image: string;
  cropType?: string;
}) {
  const { data, error } = await supabase.functions.invoke('analyze-crop-image', {
    body: {
      image: params.image,
      cropType: params.cropType
    }
  });

  return { data, error };
}